import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	deploymentsItem: {
		id: 'spa-apps-sidebar-software-classic.menu.deployments-menu-item.deployments-item',
		defaultMessage: 'Deployments',
		description: 'Navigation item which links to Deployments page in an classic project',
	},
});
